import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

import { environment } from '../../environments/environment';

import { DatabaseService } from './db-service';
import { MediaCategory, MediaStatus } from '../enums';
import { ActivityFormat, MediaPerformance, DocumentReference, NameValue, FestivalUser } from '../models';
import { FestivalUserService } from './festival-user-service';

@Injectable({
  providedIn: 'root'
})

export class MediaPerformanceService {

    public collection: string = 'mediaPerformance';

    public mediaCommitteeEmail: string = 'mediaCommitteeEmail';
    public mediaFinanceEmail: string = 'mediaFinanceEmail';

    constructor(
        private angularFirestore: AngularFirestore,
        private databaseService: DatabaseService,
        private festivalUserService: FestivalUserService) {
    }

    public getPerformanceList(churchRef: DocumentReference, category: NameValue) {
        if (churchRef && churchRef.displayName === 'All Churches') {
            if (category && category.value === 'All') 
                return this.databaseService.getDocuments(this.collection, ref => ref
                    .where('serviceYear', '==', environment.serviceYear)
                    .where('isActive', '==', true)
                    .where('isDeleted', '==', false)
                );
            return this.databaseService.getDocuments(this.collection, ref => ref
                .where('serviceYear', '==', environment.serviceYear)
                .where('category', '==', category)
                .where('isActive', '==', true)
                .where('isDeleted', '==', false)
            );
        }

        if (category && category.value === 'All') 
            return this.databaseService.getDocuments(this.collection, ref => ref
                .where('serviceYear', '==', environment.serviceYear)
                .where('church', '==', churchRef)
                .where('isActive', '==', true)
                .where('isDeleted', '==', false)
            );
        return this.databaseService.getDocuments(this.collection, ref => ref
            .where('serviceYear', '==', environment.serviceYear)
            .where('church', '==', churchRef)
            .where('category', '==', category)
            .where('isActive', '==', true)
            .where('isDeleted', '==', false)
        );
    }

    public getChurchCategoryPerformanceList(churchRef: DocumentReference, category: NameValue) {
        return this.databaseService.getDocuments(this.collection, ref => ref
            .where('serviceYear', '==', environment.serviceYear)
            .where('church', '==', churchRef)
            .where('category', '==', category)
            .where('isActive', '==', true)
            .where('isDeleted', '==', false)
        );
    }

    public getChurchFormatPerformanceList(churchRef: DocumentReference, formatRef: DocumentReference) {
        return this.databaseService.getDocuments(this.collection, ref => ref
            .where('serviceYear', '==', environment.serviceYear)
            .where('church', '==', churchRef)
            .where('format', '==', formatRef)
            .where('isActive', '==', true)
            .where('isDeleted', '==', false)
        );
    }

    public async createPerformance(performance: MediaPerformance, currentUser: FestivalUser) {
        performance.serviceYear = environment.serviceYear;
        performance.createdBy = {
            reference: this.databaseService.doc(`${this.festivalUserService.collection}/${currentUser.id}`).ref,
            displayName: currentUser.user.displayName
        }
        performance.createdAt = new Date();
        performance.updatedBy = {
            reference: this.databaseService.doc(`${this.festivalUserService.collection}/${currentUser.id}`).ref,
            displayName: currentUser.user.displayName
        }
        performance.updatedAt = new Date();

        this.angularFirestore.collection(this.collection).add({...performance});
    }

    public getPerformanceCategoryList = (): any[] => {
        const performanceCategoryList: any = [];
        
        for (var category in MediaCategory) {
            performanceCategoryList.push({ name: MediaCategory[category], value: category });
        }
        
        return performanceCategoryList; 
    }

    public getLocationList = (): any[] => {
        const performanceTypeList: any = [];
        
        performanceTypeList.push({ name: 'Melbourne Metro'               , value: 'Live Stage' });
        performanceTypeList.push({ name: 'Regional, Interstate, Overseas', value: 'Online' });


        return performanceTypeList; 
    }

    public getPerformanceStatusList = (): NameValue[] => {
        const performanceStatusList: any = [];

        for (var status in MediaStatus) {
            performanceStatusList.push({ name: MediaStatus[status], value: status });
        }

        return performanceStatusList; 
    }

    public calculatePerformanceStatus = (performance: MediaPerformance, format: ActivityFormat): MediaStatus => {

        var newStatus : MediaStatus = MediaStatus.PendingCoordinatorApproval;

        if (performance.status?.value == this.getStatusValue(MediaStatus.SubmissionCompleted)) {
            newStatus = MediaStatus.SubmissionCompleted;
        } else if (format.hasApproval && !performance.isApprovalConfirmed) {
            newStatus = MediaStatus.PendingCoordinatorApproval;
        } else if (format.hasFee && !performance.receiptNumber) { // isPaymentConfirmed
            newStatus = MediaStatus.PendingPayment; 
        } else if (format.hasFileUpload && !performance.fileUrl) {
            newStatus =  MediaStatus.PendingProject;
        } else if (format.hasCommitteeReview) {
            newStatus = MediaStatus.PendingReview;
        } else {
            newStatus = MediaStatus.SubmissionCompleted;
        }

        return newStatus;
    }

    public getStatusValue = (statusName: string): string => {

        const statusList = this.getPerformanceStatusList();
        return statusList.find(s => s.name == statusName).value;
    }
}
